var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"intersect",rawName:"v-intersect",value:({
    handler: _vm.onIntersect,
    options: {
      rootMargin: `-${_vm.rm}px`,
      threshold: [0, 0.01, 1],
    },
  }),expression:"{\n    handler: onIntersect,\n    options: {\n      rootMargin: `-${rm}px`,\n      threshold: [0, 0.01, 1],\n    },\n  }"}]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }